import axios from 'axios';
import { NamespaceMetricsResponse } from 'types/insights';
import { API_URL } from 'utils/http';

export async function getInsights({
  namespace,
  startTime,
  endTime,
}: {
  namespace: string;
  startTime: string;
  endTime: string;
}) {
  try {
    const res = await axios.get<NamespaceMetricsResponse>(`${API_URL}/insights`, {
      params: {
        namespace,
        start_time: startTime,
        end_time: endTime,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
}
